import initialState from './initialState';
import {
  FETCHING_TAX_RESERVE_REPORT,
  FETCHING_TAX_RESERVE_REPORT_SUCCESS,
  FETCHING_TAX_RESERVE_REPORT_FAILURE,
  FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS,
  FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_SUCCESS,
  FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_FAILURE,
} from './types';

import { reportName } from '../constants';
import {
  getUpdateEditedCellAction,
  getRevertEditedCellsAction,
  revertEditedCells,
  updateEditedRows,
} from '../../shared/groupedReportsStoreHelpers';

const { reportUpdateEditedCellActionType } = getUpdateEditedCellAction(reportName);
const { revertEditedCellsForGroupActionType } = getRevertEditedCellsAction(reportName);

const taxReserveReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCHING_TAX_RESERVE_REPORT:
      return {
        ...state,
        reportData: initialState.reportData,
        isFetchingReportData: true,
      };
    case FETCHING_TAX_RESERVE_REPORT_SUCCESS:
      return {
        ...state,
        reportData: payload.reportData,
        isFetchingReportData: false,
      };
    case FETCHING_TAX_RESERVE_REPORT_FAILURE:
      return {
        ...state,
        reportData: initialState.reportData,
        isFetchingReportData: false,
      };
    case FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS:
      return {
        ...state,
        isExportingReport: true,
      };
    case FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_SUCCESS:
    case FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_FAILURE:
      return {
        ...state,
        isExportingReport: false,
      };
    case reportUpdateEditedCellActionType:
      return updateEditedRows(state, payload);
    case revertEditedCellsForGroupActionType:
      return revertEditedCells(state);
    default:
      return state;
  }
};

export default taxReserveReducer;
